import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EmployeeInfo } from '@typeDefs/home/responses/home';
import { EmployeeApiService } from '@pages/employee/services/employee.api.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeeInfoService {
  private readonly employeeApiService = inject(EmployeeApiService);

  private EmployeeInfo: EmployeeInfo | null = null;
  private employeeInfoIsStale = false;
  private employeeInfoSubject = new BehaviorSubject<EmployeeInfo | null>(null);
  public employeeInfo$ = this.employeeInfoSubject.asObservable();

  public getEmployeeInfo(): EmployeeInfo | null {
    return this.EmployeeInfo;
  }

  public setEmployeeInfo(value: EmployeeInfo): void {
    this.EmployeeInfo = value;
    this.updateEmployeeInfo(value);
  }

  public setEmployeeInfoIsStale(): void {
    this.employeeInfoIsStale = true;
  }

  public fetchEmployeeInfo(): Observable<EmployeeInfo> {
    if (this.employeeInfoIsStale || this.EmployeeInfo === null) {
      return this.employeeApiService.getEmployeeInfo().pipe(
        tap(employeeInfo => {
          this.EmployeeInfo = employeeInfo;
          this.updateEmployeeInfo(employeeInfo);
          this.employeeInfoIsStale = false;
        })
      );
    }
    // Return cached value as an observable that emits once and completes
    return of(this.EmployeeInfo as EmployeeInfo);
  }

  private updateEmployeeInfo(newEmployeeInfo: EmployeeInfo): void {
    this.employeeInfoSubject.next(newEmployeeInfo);
  }
}
